import schoolReducer from './';

export default schoolReducer;
